<template>
  <ykc-form :model="ruleForm" :rules="rules" ref="ruleForm" class="el-form-wrap">
    <div class="warning-tip">本页面配置项关系对外费用结算，请谨慎操作！！！</div>
    <ykc-form-item label="电站名称">
      <div v-if="operateType === 'single'">
        {{ currentRow.stationName }}
      </div>
      <el-scrollbar v-else-if="operateType === 'multiple'" :viewStyle="{ maxHeight: '200px' }">
        <div v-for="item in selectedRows" style="margin: 4px 0" :key="item.stationId">
          {{ item.stationName }}
        </div>
      </el-scrollbar>
    </ykc-form-item>
    <ykc-form-item label="物业" v-if="operateType === 'single'">
      <div>{{ currentRow.propertyName || '——' }}</div>
    </ykc-form-item>
    <ykc-form-item label="是否收取抽成" prop="collectFlag">
      <ykc-radio :data="collectFlagData" v-model="ruleForm.collectFlag"></ykc-radio>
    </ykc-form-item>
    <template v-if="ruleForm.collectFlag === '1'">
      <ykc-form-item label="物业电费抽成" prop="powerRate">
        <div class="_line">
          <ykc-dropdown
            placeholder="请选择"
            :clearable="false"
            :data="typeData"
            :disabled="true"
            v-model="ruleForm.powerRateType"></ykc-dropdown>
          <ykc-input
            v-model="ruleForm.powerRate"
            type="number"
            :disabled="true"
            :placeholder="`请输入${ruleForm.powerRateType === '2' ? '折扣' : '单价'}`">
            <template slot="append">
              {{ appendRateType(ruleForm.powerRateType) }}
            </template>
          </ykc-input>
        </div>
      </ykc-form-item>
      <ykc-form-item label="物业服务费抽成" prop="serviceRate">
        <div class="_line">
          <ykc-dropdown
            placeholder="请选择"
            :clearable="false"
            :data="typeData"
            v-model="ruleForm.serviceRateType"></ykc-dropdown>
          <ykc-input
            v-model="ruleForm.serviceRate"
            type="number"
            :placeholder="`请输入${ruleForm.serviceRateType === '2' ? '折扣' : '单价'}`">
            <template slot="append">
              {{ appendRateType(ruleForm.serviceRateType) }}
            </template>
          </ykc-input>
        </div>
      </ykc-form-item>
    </template>

    <!-- 分成方模块（最多3个） -->
    <template v-if="operateType === 'single' && ruleForm.collectFlag === '1'">
      <div v-for="(partner, index) in ruleForm.partners" :key="index" class="partner-block">
        <div class="partner-header">
          <span>分成方{{ index + 1 }}</span>
          <ykc-button type="text" @click="removePartner(index)">删除</ykc-button>
        </div>
        <ykc-form-item
          :label="`分成方名称`"
          :prop="`partners.${index}.partnerId`"
          :rules="partnerNameRules(index)">
          <ykc-dropdown
            placeholder="请选择分成方"
            :clearable="false"
            :data="partnerOptionsFor(index)"
            v-model="partner.partnerId"
            @change="onPartnerChange(index, $event)"></ykc-dropdown>
        </ykc-form-item>
        <ykc-form-item
          label="服务费抽成"
          :prop="`partners.${index}.serviceRate`"
          :rules="partnerServiceRateRules(index)">
          <div class="_line">
            <ykc-dropdown
              placeholder="请选择"
              :clearable="false"
              :data="partnerTypeData"
              v-model="partner.serviceRateType"></ykc-dropdown>
            <ykc-input
              v-model="partner.serviceRate"
              type="number"
              :placeholder="`请输入${partner.serviceRateType === '2' ? '折扣' : '单价'}`">
              <template slot="append">
                {{ appendRateType(partner.serviceRateType) }}
              </template>
            </ykc-input>
          </div>
        </ykc-form-item>
        <ykc-form-item
          label="年费抽成"
          :prop="`partners.${index}.annualFee`"
          :rules="partnerAnnualFeeRules(index)">
          <ykc-input v-model="partner.annualFee" type="number" placeholder="请输入年费">
            <template slot="append">元/年</template>
          </ykc-input>
        </ykc-form-item>
      </div>
      <div class="add-partner-wrap">
        <ykc-button v-if="ruleForm.partners.length < 3" type="plain" @click="addPartner">
          + 添加分成方
        </ykc-button>
      </div>
    </template>
  </ykc-form>
</template>

<script>
  import { commissionStrategy } from '@/service/apis';

  export default {
    props: ['selectedRows', 'currentRow', 'operateType'],
    data() {
      return {
        collectFlagData: [
          { id: '0', name: '否' },
          { id: '1', name: '是' },
        ],
        typeData: [
          { id: '1', name: '度数' },
          { id: '2', name: '折扣' },
          { id: '3', name: '小时' },
          { id: '4', name: '次数' },
        ],
        partnerTypeData: [
          { id: '1', name: '度数' },
          { id: '2', name: '比例' },
        ],
        partnerOptions: [], // 全量非物业类分成方
        ruleForm: {
          collectFlag: '0',
          powerRateType: '1',
          powerRate: '',
          serviceRateType: '1',
          serviceRate: '',
          partners: [],
        },
        rules: {
          collectFlag: [{ required: true, message: '请选择是否收取抽成', trigger: 'blur' }],
          powerRate: [
            { required: false, message: '请输入电费抽成', trigger: 'blur' },
            {
              validator: (_, val, cb) => {
                const value = Number(val || 0);
                if (Number.isNaN(value)) {
                  return cb(new Error('只能输入数字'));
                }
                if (this.ruleForm.powerRateType === '2') {
                  if (value < 0 || value > 100) {
                    return cb(new Error('折扣比例范围为0-100'));
                  }
                  return cb();
                }
                if (this.ruleForm.powerRateType === '1') {
                  if (val.replace(/.*\.(.*)$/, '$1').length > 4) {
                    cb(new Error('最多四位小数'));
                  }
                  if (value < 0 || value > 9.9999) {
                    return cb(new Error('单价范围为0-9.9999'));
                  }
                  return cb();
                }
                return cb();
              },
              trigger: 'blur',
            },
          ],
          serviceRate: [
            { required: true, message: '请输入服务费抽成', trigger: 'blur' },
            {
              validator: (_, val, cb) => {
                const value = Number(val || 0);
                if (Number.isNaN(value)) {
                  return cb(new Error('只能输入数字'));
                }
                if (this.ruleForm.serviceRateType === '2') {
                  if (value < 0 || value > 100) {
                    return cb(new Error('折扣比例范围为0-100'));
                  }
                  return cb();
                }
                if (this.ruleForm.serviceRateType === '1') {
                  if (val.replace(/.*\.(.*)$/, '$1').length > 4) {
                    cb(new Error('最多四位小数'));
                  }
                  if (value < 0 || value > 9.9999) {
                    return cb(new Error('单价范围为0-9.9999'));
                  }
                  return cb();
                }
                return cb();
              },
              trigger: 'blur',
            },
          ],
        },
      };
    },
    created() {
      if (this.operateType === 'single') {
        this.ruleForm.collectFlag = this.currentRow.collectFlag || this.ruleForm.collectFlag;
        this.ruleForm.powerRateType = this.currentRow.powerRateType || this.ruleForm.powerRateType;
        this.ruleForm.powerRate = this.currentRow.powerRate || this.ruleForm.powerRate;
        this.ruleForm.serviceRateType =
          this.currentRow.serviceRateType || this.ruleForm.serviceRateType;
        this.ruleForm.serviceRate = this.currentRow.serviceRate || this.ruleForm.serviceRate;
        this.fillPartnersFromRow();
        this.fetchPartnerOptions();
      }
    },
    methods: {
      fillPartnersFromRow() {
        // 根据当前行数据回显分成方
        const row = this.currentRow || {};
        const list = [];
        for (let i = 1; i <= 3; i += 1) {
          const id = row[`partner${i}Id`];
          if (id !== undefined && id !== null && id !== '') {
            const serviceRate = row[`partner${i}ServiceRate`];
            const yearRate = row[`partner${i}YearRate`];
            list.push({
              partnerId: String(id),
              partnerName: '',
              serviceRateType: row[`partner${i}ServiceRateType`] || '1',
              serviceRate:
                serviceRate !== null && serviceRate !== undefined ? String(serviceRate) : '',
              annualFee: yearRate !== null && yearRate !== undefined ? String(yearRate) : '',
            });
          }
        }
        this.ruleForm.partners = list;
      },
      fetchPartnerOptions() {
        commissionStrategy.listNonPropertyPartners().then(res => {
          this.partnerOptions = (res || []).map(item => ({
            id: String(item.id),
            name: item.partnerName,
          }));
          // 下拉数据回来后，把已回显的分成方名称补齐
          this.ruleForm.partners.forEach(p => {
            const found = this.partnerOptions.find(opt => opt.id === p.partnerId);
            if (found) {
              p.partnerName = found.name;
            }
          });
        });
      },
      // 当前行可选的分成方下拉项：排除已被其他行选中的
      partnerOptionsFor(index) {
        const selected = this.ruleForm.partners
          .map((p, i) => (i !== index ? p.partnerId : null))
          .filter(Boolean);
        return this.partnerOptions.filter(opt => !selected.includes(opt.id));
      },
      onPartnerChange(index, val) {
        const found = this.partnerOptions.find(opt => opt.id === val);
        if (found) {
          this.$set(this.ruleForm.partners[index], 'partnerName', found.name);
        }
      },
      addPartner() {
        if (this.ruleForm.partners.length >= 3) return;
        this.ruleForm.partners.push({
          partnerId: '',
          partnerName: '',
          serviceRateType: '1',
          serviceRate: '',
          annualFee: '',
        });
      },
      removePartner(index) {
        this.ruleForm.partners.splice(index, 1);
      },
      partnerNameRules() {
        return [{ required: true, message: '请选择分成方', trigger: 'change' }];
      },
      partnerServiceRateRules(index) {
        return [
          {
            validator: (_, val, cb) => {
              const partner = this.ruleForm.partners[index];
              if (!partner) return cb();
              const serviceEmpty = val === '' || val === null || val === undefined;
              const annualEmpty =
                partner.annualFee === '' ||
                partner.annualFee === null ||
                partner.annualFee === undefined;
              if (serviceEmpty && annualEmpty) {
                return cb(new Error('服务费抽成与年费抽成不可同时为空'));
              }
              if (!serviceEmpty) {
                const value = Number(val);
                if (Number.isNaN(value) || value < 0) {
                  return cb(new Error('请输入合法数字'));
                }
                if (partner.serviceRateType === '2' && value > 100) {
                  return cb(new Error('折扣比例范围为0-100'));
                }
              }
              return cb();
            },
            trigger: 'blur',
          },
        ];
      },
      partnerAnnualFeeRules(index) {
        return [
          {
            validator: (_, val, cb) => {
              const partner = this.ruleForm.partners[index];
              if (!partner) return cb();
              const serviceEmpty =
                partner.serviceRate === '' ||
                partner.serviceRate === null ||
                partner.serviceRate === undefined;
              const annualEmpty = val === '' || val === null || val === undefined;
              if (serviceEmpty && annualEmpty) {
                return cb(new Error('服务费抽成与年费抽成不可同时为空'));
              }
              if (!annualEmpty) {
                const value = Number(val);
                if (Number.isNaN(value) || value < 0) {
                  return cb(new Error('请输入合法数字'));
                }
              }
              return cb();
            },
            trigger: 'blur',
          },
        ];
      },
      appendRateType(type) {
        switch (type) {
          case '1':
            return '元/度';
          case '2':
            return '%';
          case '3':
            return '元/时';
          case '4':
            return '元/次';
          default:
            return '元/度';
        }
      },
      submitForm(callback) {
        this.$refs.ruleForm.validate(valid => {
          if (!valid) return;
          if (this.operateType === 'single') {
            const data = {
              stationId: this.currentRow.stationId,
              collectFlag: this.ruleForm.collectFlag,
              powerRateType: this.ruleForm.powerRateType,
              powerRate: this.ruleForm.powerRate,
              serviceRateType: this.ruleForm.serviceRateType,
              serviceRate: this.ruleForm.serviceRate,
              partners:
                this.ruleForm.collectFlag === '1'
                  ? this.ruleForm.partners.map(p => ({
                      partnerId: Number(p.partnerId),
                      partnerName: p.partnerName,
                      serviceRateType: p.serviceRateType,
                      serviceRate: p.serviceRate,
                      annualFee: p.annualFee,
                    }))
                  : [],
            };
            commissionStrategy.submitApply(data).then(() => {
              this.$message.success('提交成功');
              callback();
            });
          } else if (this.operateType === 'multiple') {
            const data = {
              ...this.ruleForm,
              stationIds: this.selectedRows.map(({ stationId }) => stationId),
            };
            commissionStrategy.batchEdit(data).then(() => {
              callback();
            });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  ._line {
    display: flex;
    & > * {
      margin-right: 5px;
    }
  }
  .partner-block {
    border: 1px dashed #dcdfe6;
    padding: 12px;
    margin-bottom: 12px;
    border-radius: 4px;
  }
  .partner-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    font-weight: 500;
  }
  .add-partner-wrap {
    margin: 8px 0 16px;
  }
  .warning-tip {
    color: #f56c6c;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 12px;
  }
</style>
